import { useEffect } from 'react';

const useComponentReset = ({ reset }: { reset: () => void }) => {
	useEffect(() => {
		return () => {
			reset?.();
		};
	}, []);
};

export default useComponentReset;
